{
  "label": "Base map",
  "default": "Default",
  "satellite": "Satellite"
}
